import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 mt-16">
      <div className="grid grid-cols-1 md:grid-cols-4 grid-borders border-l border-zinc-900">
        <div className="p-8">
          <div className="text-2xl font-black uppercase tracking-tighter font-[Outfit]">Stuff<span className="text-[#ff3333]">ly</span></div>
          <p className="text-sm text-zinc-600 mt-3 leading-relaxed">A New Zealand bargain marketplace. Curated imports, fair pricing, fast shipping.</p>
        </div>
        <div className="p-8">
          <div className="text-xs uppercase tracking-widest font-bold mb-4 font-[Outfit]">Shop</div>
          <ul className="text-sm space-y-2">
            <li><a href="/products" className="hover:underline">All Products</a></li>
            <li><a href="/products?sort=price-asc" className="hover:underline">Cheapest First</a></li>
            <li><a href="/products?q=phone" className="hover:underline">Phone Accessories</a></li>
            <li><a href="/products?q=tool" className="hover:underline">Tools</a></li>
            <li><a href="/blog" className="hover:underline">Blog & Guides</a></li>
          </ul>
        </div>
        <div className="p-8">
          <div className="text-xs uppercase tracking-widest font-bold mb-4 font-[Outfit]">Support</div>
          <ul className="text-sm space-y-2">
            <li>Shipping NZ Wide</li>
            <li>1 Year Warranty</li>
            <li>Stripe Secure Checkout</li>
            <li>NZD Pricing</li>
          </ul>
        </div>
        <div className="p-8 bg-zinc-900 text-white relative noise">
          <div className="text-xs uppercase tracking-widest font-bold mb-4 font-[Outfit]">Deals In Your Inbox</div>
          <p className="text-sm opacity-80 mb-4">New arrivals, guides and exclusive offers. No spam.</p>
          <NewsletterForm dark />
          <p className="text-sm mt-5 opacity-60">Auckland · New Zealand · support@stuffly.nz</p>
        </div>
      </div>
      <div className="border-t border-zinc-900 px-6 py-4 text-xs uppercase tracking-widest font-[Outfit] font-bold flex flex-col md:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Stuffly</span>
        <span>Powered by Stripe · Built In NZ</span>
      </div>
    </footer>
  );
}
